// src/config.js
// App configuration based on environment variables

export const SYSTEM_NAME = process.env.REACT_APP_SYSTEM_NAME || "XLerate Local";

// IT support contact, shown in the Sign-in footer.
export const SUPPORT_CONTACT = {
  email: process.env.REACT_APP_SUPPORT_EMAIL || "it@xl-property.co.uk",
  phone: process.env.REACT_APP_SUPPORT_PHONE || "01474 333 100",
};
export const APP_ENVIRONMENT =
  process.env.REACT_APP_APP_ENVIRONMENT ||
  process.env.REACT_APP_ENVIRONMENT ||
  "";

const normalizedEnvironment = APP_ENVIRONMENT.toUpperCase();
if (normalizedEnvironment === "UAT" || normalizedEnvironment === "DEV") {
  console.log(`REACT_APP_APP_ENVIRONMENT=${normalizedEnvironment}`);
}
